import { render, staticRenderFns } from "./SideMenuItem_2.vue?vue&type=template&id=3a04b978&scoped=true&"
import script from "./SideMenuItem_2.vue?vue&type=script&lang=js&"
export * from "./SideMenuItem_2.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuItem_2.vue?vue&type=style&index=0&id=3a04b978&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a04b978",
  null
  
)

export default component.exports